(function() {
'use strict';

const TR = angular.module('TR');
TR.directive('compactRoomGrid', function(
    $route,
    $filter,
    scrollService,
    broker,
    hotelRoomService,
    occupancyService,
    cookieService,
    tripService,
    analytics,
    mandatoryTransferService
) {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            priceMode: '=',
            numNights: '=',
            selectRooms: '&',
            showModal: '&',
            totalHolidayPrice: '=bind',
            totalRoomsPromoDelta: '=',
            flightCostPerPerson: '=',
            flightCostTotal: '=',
            holidayMode: '=',
            currencyCode: '@',
            roomsLeftLimit: '=',
            packagePrice: '=',
            marhabaCost: '=?',
            isKidsFree: '=',
            showCityTax: '=',
        },
        transclude: false,
        templateUrl: 'partials/home/directivetemplate?type=CompactRoomGrid',
        link(scope) {
            scope.roomGridData = [];
            scope.selectedPrices = {};
            scope.defaultMultipleRoomsSelection = {};
            scope.showAllRooms = false;
            scope.roomsToShow = 2;
            scope.selectSingleRoom = selectSingleRoom;
            scope.selectMultipleRooms = selectMultipleRooms;
            scope.totalRoomCosts = 0;
            scope.totalRoomCostsOriginal = 0;
            scope.showMessagePopup = false;
            scope.pickRooms = pickRooms;
            scope.moreRooms = 0;
            scope.toggleExtraRooms = toggleExtraRooms;
            scope.totalNonInfants = 0;
            scope.openImageGallery = openImageGallery;
            scope.roomImages = [];
            scope.showRoomImages = false;
            scope.priceExcludesTax = TRPCONFIG.Domain.PriceExcludesTax || false;
            scope.marhabaCost = scope.marhabaCost || 0;
            scope.showDiscount = TRPCONFIG.Domain.SeasonalDeals && TRPCONFIG.Domain.SeasonalDeals.isPillVisible;
            scope.showStrikethroughPrice = TRPCONFIG.Domain.EnableStrikethroughPrices || false;
            scope.callToBookEnabled = TRPCONFIG.Domain.CallToBookEnabled;
            scope.trueRooms = [];
            TRPCONFIG.Domain.totalHolidayPrice = undefined;

            let puc = sessionStorage.getItem('PopUpConfirmed');
            if (puc) {
                window.addEventListener('popstate', () => {
                    const pageHistory = JSON.parse(sessionStorage.getItem('URLstorage') || '{}');
                    const pages = pageHistory && pageHistory.pages ? pageHistory.pages : [];
                    if (pages.length && pages[pages.length - 2] === 'Choose your Room'
                        && pages[pages.length - 1] === 'Choose your Flight'
                    ) {
                        let t = JSON.parse(localStorage.getItem('trip') || '');
                        let cc = TRPCONFIG.Domain.CultureCode;
                        let countryCode = TRPCONFIG.Domain.CountryCode;
                        countryCode = countryCode.toLowerCase();
                        let c = cc.split('-');
                        c = `${countryCode}_${c[0]}`;
                        let newURL = `${window.location.origin}/${c}/holidays/hotels/${t.TripId}`;
                        window.location.replace(newURL);
                    }
                });
            }

            scope.holidayWasAmount = (p, room) =>
                p.OriginalCost / (scope.priceMode === 0 ? room.nonInfants : 1) +
                (scope.priceMode === 0 ? scope.flightCostPerPerson :
                    scope.flightCostTotal * (room.nonInfants / scope.totalNonInfants));
            scope.holidayAmount = (p, room) =>
                p.Cost / (scope.priceMode === 0 ? room.nonInfants : 1) +
                (scope.priceMode === 0 ? scope.flightCostPerPerson :
                    scope.flightCostTotal * (room.nonInfants / scope.totalNonInfants));
            scope.holidayDiscountPercentage = p => {
                if (!scope.packagePrice && p.DiscountPercentage > 0) {
                    return p.DiscountPercentage;
                }
            };
            scope.getBasePrice = p => {
                if (p.BoardOptions[0] && p.BoardOptions[0].Cost) {
                    return p.BoardOptions[0].Cost;
                }
                return 0;
            };
            scope.checkIsBasePrice = (base, current) => {
                if (base === current) {
                    return true;
                }
                return false;
            };

            scope.boardBasis = boardTypes => {
                return hotelRoomService.boardBasis(boardTypes);
            };

            scope.displayBoardPrice = (room, price, priceMode) => {
                return price.Cost / (priceMode === 0 ? room.nonInfants : 1) + (((scope.marhabaCost || 0) / (priceMode === 0
                    ? room.nonInfants : 1)) / (scope.roomGridData.length || 1)) + (priceMode === 0 ? scope.flightCostPerPerson
                    : scope.flightCostTotal * (room.nonInfants / scope.totalNonInfants));
            };

            scope.showIncluded = (room, p) => {
                let priceItem = $filter('roundedCurrency')(scope.displayBoardPrice(room, p, 1)) === $filter('roundedCurrency')(scope.holidaySummaryCost(room, 1));
                if (priceItem) {
                    scope.trueRooms.push(p.RoomDescription);
                }

                let uniqueArray = scope.trueRooms.filter((item, pos, self) => {
                    return self.indexOf(item) === pos;
                });

                if (uniqueArray.length > 1) {
                    if (uniqueArray[0] === p.RoomDescription) {
                        priceItem = true;
                    } else {
                        priceItem = false;
                    }
                }

                return priceItem;
            };

            scope.holidaySummaryCost = (room, priceMode) => {
                let holidaySummaryCost;
                if (scope.roomGridData && scope.roomGridData.length > 1) {
                    holidaySummaryCost = priceMode === 0 ? (scope.hotel.MinCostPerPerson + scope.flightCostPerPerson + ((scope.marhabaCost || 0) / room.nonInfants / (scope.roomGridData.length || 1))) :
                        (scope.selectedRoomsCost[room.Id] + scope.flightCostTotal * (room.nonInfants / scope.totalNonInfants) + ((scope.marhabaCost || 0) / (scope.roomGridData.length || 1)));
                } else {
                    holidaySummaryCost = priceMode === 0 ? (scope.hotel.MinCostPerPerson + scope.flightCostPerPerson + ((scope.marhabaCost || 0) / room.nonInfants / (scope.roomGridData.length || 1))) :
                        (scope.hotel.MinCost / (scope.roomGridData.length || 1) + scope.flightCostTotal * (room.nonInfants / scope.totalNonInfants) + ((scope.marhabaCost || 0) / (scope.roomGridData.length || 1)));
                }
                return holidaySummaryCost;
            };

            scope.displayTotalBoardPrice = (room, price) => {
                let dynamicTotalPrice = Object.assign({}, scope.selectedRoomsCost);
                dynamicTotalPrice[room.Id] = price.Cost;
                let roomPrices = Object.values(dynamicTotalPrice);
                let hotelPrice = roomPrices.reduce(function(a, b) {
                    return a + b;
                });
                return hotelPrice + (scope.marhabaCost || 0) + scope.flightCostTotal;
            };

            scope.updateRoomChange = (room, p) => {
                if (p.Id === scope.selectedPrices[room.Id]) {
                    scope.defaultMultipleRoomsSelection[room.Id] = p.Id;
                    scope.selectedRoomsCost[room.Id] = p.Cost;
                    let roomPrices = Object.values(scope.selectedRoomsCost);
                    let hotelPrice = roomPrices.reduce(function(a, b) {
                        return a + b;
                    });
                    scope.hotel.MinCost = p.Cost * roomPrices.length;
                    scope.totalHolidayPrice = hotelPrice + (scope.marhabaCost || 0) + scope.flightCostTotal;
                    if (scope.showStrikethroughPrice && p.Promotions && p.Promotions.length > 0) {
                        const promo = p.Promotions.filter(pr => pr.Type === 6);
                        const appliedPromo = promo.length > 0 ? promo.filter(pr => pr.Prices.Price === p.Cost) : null;
                        if (appliedPromo && appliedPromo.length > 0 && appliedPromo[0].Prices.WasPrice) {
                            scope.selectedRoomsPromoDelta[room.Id] = appliedPromo[0].Prices.WasPrice - p.Cost;
                        }
                        const roompromoDelta = Object.values(scope.selectedRoomsPromoDelta);
                        if (roompromoDelta && roompromoDelta.length > 0) {
                            scope.totalRoomsPromoDelta = roompromoDelta.reduce(function(a, b) {
                                return a + b;
                            });
                        }
                    }
                    const boardRoomUpdatedInfo = {
                        id: room.Id, roomDescription: p.RoomDescription, boardDescription: p.BoardDescription
                    };
                    broker.publish('boardRoomUpdate', boardRoomUpdatedInfo);
                    broker.publish('boardPriceSelectionsUpdate', scope.totalHolidayPrice);
                }
            };

            scope.getSkywardsMiles = bt => {
                let hts = sessionStorage.getItem('hotelDetailsSkywards');
                hts = JSON.parse(hts);
                let miles;

                if (hts && hts.length) {
                    for (let a = 0; a < hts.length; a++) {
                        if (bt.ProductId === hts[a].Id) {
                            miles = hts[a].Miles;
                        }
                    }
                }

                return miles;
            };
            scope.getFlightMiles = () => {
                try {
                    let flight = sessionStorage.getItem('SkywardsMilesFlights');
                    flight = JSON.parse(flight);
                    let miles;
                    if (flight) {
                        miles = flight;
                    }
                    return miles;
                } catch (error) {}
            };
            broker.subscribe('CompactRoomGrid', 'roomsSet', function(ev) {
                scope.hotel = ev.data;
                _restructureData();
            });

            broker.subscribe('CompactRoomGrid', 'continueToBookFromFlightDetailsModal', function(e) {
                if (e.data.multipleRoomMode) {
                    mandatoryTransferService.generateMandatoryOptions(scope.selectedPrices, e.data.flightDetails);
                    pickRooms();
                } else {
                    mandatoryTransferService.generateMandatoryOptions(e.data.roomId, e.data.flightDetails);
                    continueToBook(e.data.roomId, e.data.priceId);
                }
            });

            scope.$on('$destroy', () => {
                broker.unsubscribe('CompactRoomGrid');
            });

            scope.showMultiRoomDates = () => {
                let show;
                if (TRPCONFIG.Domain.CancellationData) {
                    let data = TRPCONFIG.Domain.CancellationData;
                    for (let i = 0; i < data.length; i++) {
                        if (data[i].CancellationCharges && data[i].CancellationCharges[0]
                            && data[i].CancellationCharges[0].Amount > 0) {
                            show = false;
                        } else {
                            show = true;
                        }
                    }
                } else {
                    show = false;
                }
                return show;
            };

            scope.hasStoreSelectedFlight = function() {
                return sessionStorage.getItem('storeSelectedFlight') ? sessionStorage.getItem('storeSelectedFlight') : sessionStorage.getItem('DefaultFlight');
            };

            scope.getMultiRoomDate = id => {
                if (TRPCONFIG.Domain.CancellationData) {
                    let data = TRPCONFIG.Domain.CancellationData;
                    let dates = [];
                    for (let i = 0; i < data.length; i++) {
                        if (data[i].Id === id) {
                            let charges = data[i].CancellationCharges;
                            for (let j = 0; j < charges.length; j++) {
                                if (charges[j].Amount > 0) {
                                    dates.push(charges[j].EventDate);
                                }
                            }
                        }
                    }
                    if (!sessionStorage.getItem('chargeDates')) {
                        sessionStorage.setItem('chargeDates', dates[0]);
                    }
                    return dates[0];
                }
            };

            scope.hasChargeDates = () => {
                if (sessionStorage.getItem('chargeDates') && sessionStorage.getItem('chargeDates') !== 'undefined') {
                    return true;
                }
                return false;
            };

            scope.getChargeDates = () => {
                if (sessionStorage.getItem('chargeDates') && sessionStorage.getItem('chargeDates') !== 'undefined') {
                    return sessionStorage.getItem('chargeDates');
                }
            };

            scope.isMultiRoom = () => {
                let hotelData = JSON.parse(sessionStorage.getItem('hotelData'));
                if (hotelData.RequestedRooms.length > 1) {
                    return true;
                }
                return false;
            };

            scope.chargesCheck = id => {
                if (TRPCONFIG.Domain.CancellationData) {
                    let data = TRPCONFIG.Domain.CancellationData;
                    for (let i = 0; i < data.length; i++) {
                        if (id === data[i].Id) {
                            return data[i].CancellationCharges[0].Amount;
                        }
                    }
                }
            };

            scope.showCancellationsDetails = Id => {
                scope.roomId = Id;
                broker.publish('showModalCancellationsDetails', Id);
                broker.publish('setRoomId', Id);
            };

            scope.getRefundableDate = id => {
                if (TRPCONFIG.Domain.CancellationData) {
                    return compareRefundableDates(TRPCONFIG.Domain.CancellationData, id);
                }

                let intvl = setInterval(() => {
                    if (TRPCONFIG.Domain.CancellationData) {
                        clearInterval(intvl);
                        return compareRefundableDates(TRPCONFIG.Domain.CancellationData, id);
                    }
                }, 100);
            };

            scope.getRoomId = id => {
                let clickedElement = document.querySelector(`[data-room-id="${id}"]`);
                hotelRoomService.getNoOfRooms(id, clickedElement.parentElement.parentElement.parentElement);
            };

            function compareRefundableDates(data, id) {
                for (let i = 0; i < data.length; i++) {
                    if (id === data[i].Id) {
                        return data[i].RefundableCutOffDate;
                    }
                }
            }

            function _findHotelRoomPrices(hotelData, findTemplate) {
                hotelData.forEach(({ Availability, nonInfants }) =>
                    Availability.forEach(({ BoardTypes }) =>
                        BoardTypes.forEach(({ Prices }) =>
                            Prices.forEach(Price => findTemplate(Price, nonInfants))
                        )
                    )
                );
            }

            function _restructureData() {
                //For the compact grid view let the usual room stuff happen and then restructure the data
                //in to the format we want.
                scope.hotel.Rooms.forEach(room => {
                    if (!room.Availability[0].ProductId) {
                        hotelRoomService.setBoardId(room.Availability, room.FilteredAvailability);
                    }
                });
                const hotelData = hotelRoomService.restructureData(scope.hotel);
                scope.roomGridData = hotelData;
                hotelRoomService.getBoardTotal(scope.roomGridData, scope.priceMode, scope.marhabaCost, scope.flightCostPerPerson, scope.flightCostTotal, scope.totalNonInfants);
                //set up array to hold the selected rooms, really only because of multiroom
                scope.selectedPrices = {};
                scope.defaultMultipleRoomsSelection = {};
                scope.selectedRoomsCost = {};
                scope.selectedRoomsPromoDelta = {};
                for (let i = 0; i < hotelData.length; i++) {
                    scope.selectedPrices[hotelData[i].Id] = (hotelData.length > 1 && hotelData[i].Availability[0])
                        ? hotelData[i].Availability[0].BoardTypes[0].Prices[0].Id : null;
                    scope.defaultMultipleRoomsSelection[hotelData[i].Id] = (hotelData.length > 1 && hotelData[i].Availability[0])
                        ? hotelData[i].Availability[0].BoardTypes[0].Prices[0].Id : null;
                    scope.selectedRoomsCost[hotelData[i].Id] = (hotelData.length > 1 && hotelData[i].Availability[0])
                        ? hotelData[i].Availability[0].BoardTypes[0].Prices[0].Cost : null;
                    if (scope.showStrikethroughPrice && hotelData.length > 1 && hotelData[i].Availability[0] && hotelData[i].Availability[0].BoardTypes[0] &&
                            hotelData[i].Availability[0].BoardTypes[0].Prices[0] && hotelData[i].Availability[0].BoardTypes[0].Prices[0].Promotions &&
                            hotelData[i].Availability[0].BoardTypes[0].Prices[0].Promotions.length > 0) {
                            const promo = hotelData[i].Availability[0].BoardTypes[0].Prices[0].Promotions.filter(pr => pr.Type === 6);
                            const appliedPromo = promo.filter(function(promo) {
                                return promo.Prices ? promo.Prices.Price === hotelData[i].Availability[0].BoardTypes[0].Prices[0].Cost && promo.ShowWasNowPrice : false;
                            });
                            if (appliedPromo.length > 0 && appliedPromo[0].Prices && appliedPromo[0].Prices.WasPrice && scope.selectedRoomsCost[hotelData[i].Id]) {
                                scope.selectedRoomsPromoDelta[hotelData[i].Id] = appliedPromo[0].Prices.WasPrice - scope.selectedRoomsCost[hotelData[i].Id];
                            }
                            const roompromoDelta = Object.values(scope.selectedRoomsPromoDelta);
                            if (roompromoDelta && roompromoDelta.length > 0) {
                                scope.totalRoomsPromoDelta = roompromoDelta.reduce(function(a, b) {
                                    return a + b;
                                });
                            }
                        }
                    }
                if (hotelData.length > 0) {
                    if (scope.showCityTax && TRPCONFIG.Domain.EnableCityTax) {
                        let estabList = [];

                        _findHotelRoomPrices(hotelData, ({ Cost }, nonInfants) => estabList.push({
                            EstabId: scope.hotel.Id,
                            CurrencyCode: TRPCONFIG.Domain.CurrencyCode,
                            TotalCost: Cost / (scope.priceMode === 0 ? nonInfants : 1)
                        }));

                    }

                    const totalRooms = _.reduce(_.map(hotelData, function(rr) { return rr.Availability.length; }), function(n, m) { return n + m; }, 0);
                    scope.moreRooms = totalRooms - (hotelData.length * scope.roomsToShow);
                    scope.totalNonInfants = scope.isKidsFree
                        ? occupancyService.getOnlyPayingIndividuals()
                        : _.reduce(hotelData, function(n, m) { return n + m.nonInfants; }, 0);
                }
            }

            function selectSingleRoom(roomId, priceId, roomIndex, roomInfo = {}) {
                sessionStorage.removeItem('PopUpConfirmed');
                TRPCONFIG.Domain.DefaultHotelDates = true;
                if (TRPCONFIG.Domain.MandatoryExtrasEnabled && !scope.holidayMode) {
                    checkMandatoryTransfers(roomInfo, roomId, priceId, roomIndex);
                } else {
                    continueToBook(roomId, priceId);
                }
            }

            function selectMultipleRooms() {
                sessionStorage.removeItem('PopUpConfirmed');
                TRPCONFIG.Domain.DefaultHotelDates = true;
                if (TRPCONFIG.Domain.MandatoryExtrasEnabled && !scope.holidayMode) {
                    const roomsWithMandatoryTransfer = mandatoryTransferService.getRoomsWithTransfers(scope.hotel, scope.roomGridData, scope.selectedPrices);
                    roomsWithMandatoryTransfer.length > 0 ? selectTransferForMultiRoom(roomsWithMandatoryTransfer) : pickRooms();
                } else {
                    pickRooms();
                }
            }

            function selectTransferForMultiRoom(rooms) {
                const priceMode = scope.priceMode;
                broker.publish('showModalAddFlightDetailsForMultiRooms', { rooms, priceMode });
            }

            function checkMandatoryTransfers(roomInfo, roomId, priceId, roomIndex) {
                const mandatoryTransfers = mandatoryTransferService.getTransfers(roomInfo.Extras);
                let showMandatoryExtrasModal = roomInfo.Extras ?
                                            mandatoryTransfers.length > 0 :
                                            false;
                const priceMode = scope.priceMode;
                const totalNonInfants = scope.totalNonInfants;
                showMandatoryExtrasModal ? broker.publish('showModalAddFlightDetails', { roomId, priceId, roomInfo, roomIndex, priceMode, totalNonInfants }) : continueToBook(roomId, priceId);
            }

            function continueToBook(roomId, priceId) {
                const isPriceIdArray = _.isArray(priceId);
                if (isPriceIdArray && priceId.length === 1) {
                    priceId = priceId.join();
                }

                analytics.trackEvent({ category: 'searches', action: 'optionsPage' });
                scope.selectedPrices[roomId] = priceId;
                cookieService.set('SelectedPrices', scope.selectedPrices[roomId]);
                cookieService.set('VoucherCode', '');
                cookieService.set('VoucherWarnMessage', '');

                pickRooms();
            }

            function pickRooms() {
                if (_.some(scope.selectedPrices, function(p) { return p == null; })) {
                    scope.showMessagePopup = true;
                } else {
                    const arr = _.map(scope.selectedPrices);
                    scope.selectRooms({ ids: arr });
                }
            }

            function toggleExtraRooms() {
                if (scope.showAllRooms) {
                    scrollService.scrollTo('#roomsPanel', { animate: true }).then(function() {
                            scope.showAllRooms = !scope.showAllRooms;
                    });
                } else {
                    scope.showAllRooms = !scope.showAllRooms;
                }
            }

            function openImageGallery(url, e) {
                e.preventDefault();

                scope.roomImages = [];
                scope.roomImages.push({ src: url });
                scope.showRoomImages = true;
            }

        }
    };
});
})();
